// extracted by mini-css-extract-plugin
export var addToCartButton = "_j6-b";
export var arrowButtonContainer = "_j6-9";
export var arrowButtonIcon = "_j6-a";
export var carouselArrowButton = "_j6-6";
export var carouselElementContainer = "_j6-1";
export var left = "_j6-7";
export var productDisplayCarouselContainer = "_j6-0";
export var productTileContainer = "_j6-2";
export var productTileImage = "_j6-4";
export var productTileImageContainer = "_j6-3";
export var productTileTitle = "_j6-5";
export var right = "_j6-8";
export var sliderOverflow = "_j6-c";